import { emptyObject } from '@constants/empty';
import { processScheduleCardInfo } from '@cont/Store/TestSeries/FullSchedule/utils';
import { SWRConfig } from 'swr';
import {
  fetchScheduleCard,
  getScheduleInfoKey
} from '@api/fetchers/test-series';
import Layout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import Header from '@cont/Store/TestSeries/FullSchedule/Header';
import CardsContainer from '@cont/Store/TestSeries/FullSchedule/CardsContainer';

const Schedule = ({ courseUID, fallback }) => {
  const scheduleCardKey = getScheduleInfoKey(courseUID);

  return (
    <SWRConfig
      value={{
        fallback: {
          [scheduleCardKey]: fallback.cardsByDate
        }
      }}
    >
      <Header />
      <CardsContainer />
    </SWRConfig>
  );
};

Schedule.pageInfo = {
  name: 'Full Schedule',
  isMWebSupported: true,

  layoutOptions: {
    hideFooter: true,
    noMobilePadding: true,
    useLightBaseColor: true
  }
};

export const getStaticProps = async ({ params }) => {
  const { courseUID } = params ?? emptyObject;

  try {
    const resp = await fetchScheduleCard(courseUID);
    const processedScheduleInfo = processScheduleCardInfo(resp);

    return {
      props: {
        fallback: {
          cardsByDate: processedScheduleInfo
        },
        courseUID
      },
      revalidate: 5 * 60
    };
  } catch {
    return { notFound: true, revalidate: 2 * 60 };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

export default Schedule;

Schedule.Layout = Layout;
Schedule.Wrapper = PageReduxProvider;
